export default __webpack_public_path__ + "static/media/pin.3fbd21e6.svg";